import IconButton from '@mui/material/IconButton';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { useNavbarSlice, selectNavbarActions } from 'app/store/navbarSlice';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

function NavbarToggleButton(props) {
  const { navbarToggleMobile, navbarToggle } = useNavbarSlice(selectNavbarActions);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <IconButton
      className={props.className}
      color="inherit"
      size="small"
      onClick={() => {
        if (isMobile) navbarToggleMobile();
        else navbarToggle();
      }}
    >
      {props.children}
    </IconButton>
  );
}

NavbarToggleButton.defaultProps = {
  children: (
    <FuseSvgIcon size={20} color="action">
      heroicons-outline:view-list
    </FuseSvgIcon>
  ),
};

export default NavbarToggleButton;
